<ng-container *ngIf="showLoader; else content">
  <app-loading-sti></app-loading-sti>
</ng-container>

<ng-template #content>
  <ion-content class="modal-outher-container">
    <ion-grid class="modal-inner-container">
      <ion-row>
        <ion-col>
          <app-modal-header
            header="{{ 'DEPARTMENT.SELECT_DEPARTMENT' | translate }}"
            (close)="close()"
            *ngIf="companyGroupDepartments?.length > 0"
          >
          </app-modal-header>

          <app-modal-header
            header="{{ 'USERS.NO_DEPARTMENTS' | translate }}"
            (close)="close()"
            *ngIf="companyGroupDepartments?.length == 0"
          >
          </app-modal-header>

          <form
            [formGroup]="form"
            (ngSubmit)="Save()"
            class="add-company-department__form-container"
            *ngIf="companyGroupDepartments?.length > 0"
          >
            <ion-grid>
              <ion-row>
                <ion-col size="12">
                  <app-select-dropdown
                    formControlName="department"
                    [data]="companyGroupDepartments"
                    (touchEvent)="onSelectTouched('department')"
                  ></app-select-dropdown>

                  <ion-label
                    *ngIf="!form.get('department').valid && (form.get('department').touched || validationError)"
                    color="danger"
                    class="font-size__16"
                  >
                    {{"REQUIRED_VALIDATION" | translate}}
                  </ion-label>
                  <ion-item *ngIf="errorMessage.length > 0" lines="none">
                    <ion-label color="danger" class="font-size__16">
                      {{ errorMessage | translate }}
                    </ion-label>
                  </ion-item>

                  <ion-item class="input" lines="none">
                    <ion-button
                      type="submit"
                      class="button-margin-top-md"
                      size="medium"
                      slot="end"
                      >{{'SAVE' | translate }}
                    </ion-button>
                  </ion-item>
                </ion-col>
              </ion-row>
            </ion-grid>
          </form>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-content>
</ng-template>
